<template>
  <van-overlay z-index="999" :show="show" @click="clickFn">
    <div class="overlay-wrapper" :class="`overlay-wrapper-${position}`" @click.stop>
      <slot />
    </div>
  </van-overlay>
</template>
<script>
import { stopBodyScroll } from '@utils';
export default {
  props: {
    clickFn: {
      type: Function,
      default: () => {}
    },
    show: {
      required: true,
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'center'
    }
  },
  destroyed() {
    try {
      stopBodyScroll(false);
    } catch (e) {
      console.log('document error');
    }
  },
  watch: {
    show: {
      handler: function(v) {
        try {
          stopBodyScroll(v);
        } catch (e) {
          console.log('document error');
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="less" scoped>
.overlay-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.overlay-wrapper-center {
  align-items: center;
  justify-content: center;
}
.overlay-wrapper-left {
  justify-content: flex-start;
}
.overlay-wrapper-right {
  justify-content: flex-end;
}
</style>
